import { useTranslation } from 'react-i18next';
import { Card, Text, makeStyles, tokens } from '@fluentui/react-components';
import { quickStartSections } from './quickStartData';
import { pageShell } from '../components/layout/pageShell';

// STX-PROD-09 — the staff Quick start. Static, bilingual, no data: it must read correctly on the
// first day and on a quiet day alike. Sections and their points come from quickStartData.ts.

const useStyles = makeStyles({
  page: {
    ...pageShell,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  title: {
    fontSize: tokens.fontSizeHero800,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: '1.1',
    margin: 0,
  },
  intro: { color: tokens.colorNeutralForeground3, fontSize: tokens.fontSizeBase300 },
  // Full width without page-long lines: the sections flow into columns, each at a readable measure.
  sections: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 560px), 1fr))',
    gap: tokens.spacingVerticalL,
    alignItems: 'start',
  },
  card: { padding: tokens.spacingVerticalL },
  sectionTitle: {
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
    margin: 0,
  },
  points: {
    margin: 0,
    marginTop: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalXL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    lineHeight: tokens.lineHeightBase400,
  },
});

export default function QuickStartPage() {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <Text as="h1" className={styles.title}>{t('quickStartPage.title')}</Text>
        <Text className={styles.intro}>{t('quickStartPage.intro')}</Text>
      </div>
      <div className={styles.sections}>
      {quickStartSections.map((section, i) => (
        <Card key={section.key} className={styles.card} data-testid={`quick-start-${section.key}`}>
          <h2 className={styles.sectionTitle}>
            {`${i + 1}. ${t(`quickStartPage.sections.${section.key}.title`)}`}
          </h2>
          <ul className={styles.points}>
            {section.points.map((point) => (
              <li key={point}>{t(`quickStartPage.sections.${section.key}.points.${point}`)}</li>
            ))}
          </ul>
        </Card>
      ))}
      </div>
    </div>
  );
}
